import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCheck, faCircle, faTimes } from '@fortawesome/pro-light-svg-icons';
import { CreNgModule, SpinnerModule } from 'cre-ng';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';

import { ServiceFactory } from '@app/core/services/service.factory';
import { SharedModule } from '../shared/shared.module';
import { WigDaily5Component } from './wig-daily5-form.component';

@NgModule({
  declarations: [WigDaily5Component],
  exports: [WigDaily5Component],
  imports: [
    CommonModule,
    ConfirmDialogModule,
    CreNgModule,
    FormsModule,
    MessageModule,
    MessagesModule,
    ReactiveFormsModule,
    SpinnerModule,
    SharedModule,
  ],
  providers: [ConfirmationService, ServiceFactory],
})
export class WigDaily5Module {
  constructor(library: FaIconLibrary) {
    // Font Awesome Icons to consume
    library.addIcons(faCheck, faCircle, faTimes);
  }
}
